'use client'

import { FC } from 'react'

import { Content } from '@/api'
import { Button } from '@/uikit/button'
import { Container } from '@/uikit/container'

import styles from './video-block.module.scss'

interface VideoBlockProps {
  content?: Content
}

export const VideoBlock: FC<VideoBlockProps> = ({ content }) => {
  if (!content) return null

  const { otherData } = content

  if (!otherData) return null

  const { header, text, channelLink, link } = otherData

  const src = `https://rutube.ru/play/embed/${link}/?skinColor=1FA050`

  return (
    <Container>
      <div className={styles.root}>
        <h2>{content.header}</h2>
        <div className={styles.content}>
          {link && (
            <div className={styles.video}>
              <iframe
                width="100%"
                height="100%"
                src={src}
                style={{ border: 'none' }}
                allow="clipboard-write; autoplay"
                allowFullScreen
              />
            </div>
          )}
          <div className={styles.text_block}>
            <div className={styles.subtitle}>{header}</div>
            <div className={styles.text}>{text}</div>
            {channelLink && (
              <Button variant="green-link" href={channelLink} target="_blank">
                Перейти на Rutube канал
              </Button>
            )}
          </div>
        </div>
      </div>
    </Container>
  )
}
